var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVietnamese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1874)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_172_1874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 0H30.9989V23H0.00195312V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_172_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.9375 0H32.9375V23H-1.9375V0Z",
    fill: "#DA251D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7509 17.1158L15.6821 14.1195L11.6406 17.1428L13.1392 12.2193L9.09766 9.17813L14.0973 9.1332L15.6503 4.21875L17.2261 9.11973L22.2257 9.12422L18.2069 12.1969L19.7463 17.1203L19.7509 17.1158Z",
    fill: "#FFFF00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamese);
export default __webpack_public_path__ + "static/media/Vietnamese.0e376bae2cad964d3b4b1f13a8ffc795.svg";
export { ForwardRef as ReactComponent };